<div class="card subscribe-card">
    <div class="content-container">
        <div class="content card-content-centered">
            <div class="card-header h1-text" translate>unsubscribe.Unsubscribe Successful</div>
            <div class="card-text field" translate [translateParams]="{email: emailName, school: schoolName}">unsubscribe.You will no longer receive emails</div>
            <div class="buttonbar buttonbar-bottom">
                <a class="btn btn_primary btn_link" translate (click)='gotoEmailPreferences()'>unsubscribe.Manage email preferences</a>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="content"><span translate>unsubscribe.Unsubscribed by accident?</span><a (click)='resubscribe()' translate> unsubscribe.Subscribe again</a></div>
    </div>
</div>
